import React from "react";

interface Props {
  width: number;
  height: number;
}

const SvgMix = (props: Props) => (
  <svg
    {...props}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.17683 12.1463C5.90122 12.1463 6.54512 11.9049 7.10854 11.5024C7.26951 11.3415 7.67195 11.422 7.83293 11.6634C8.07439 11.9049 8.07439 12.3073 7.75244 12.5488C7.02805 13.0317 6.14268 13.3537 5.17683 13.3537C3.96951 13.3537 2.84268 12.8707 2.0378 12.0659C1.23293 11.261 0.75 10.1341 0.75 8.92683C0.75 7.71951 1.23293 6.59268 2.0378 5.7878C2.84268 4.98293 3.96951 4.5 5.17683 4.5C6.38415 4.5 7.51098 4.98293 8.23537 5.7878L11.0524 8.60488C11.2939 8.84634 11.2939 9.24878 11.0524 9.49024C10.972 9.57073 10.811 9.65122 10.65 9.65122C10.489 9.65122 10.328 9.57073 10.2476 9.49024L7.43049 6.67317C6.86707 6.02927 6.0622 5.70732 5.17683 5.70732C4.37195 5.70732 3.56707 6.10976 2.92317 6.67317C2.27927 7.23659 1.95732 8.04146 1.95732 8.92683C1.95732 9.8122 2.35976 10.5366 2.92317 11.1805C3.48659 11.8244 4.29146 12.1463 5.17683 12.1463ZM12.8232 4.5C14.0305 4.5 15.1573 4.98293 15.9622 5.7878C16.7671 6.59268 17.25 7.71951 17.25 8.92683C17.25 10.1341 16.7671 11.261 15.9622 12.0659C15.1573 12.8707 14.0305 13.3537 12.8232 13.3537C11.6159 13.3537 10.489 12.8707 9.68415 12.0659L6.86707 9.24878C6.62561 9.00732 6.62561 8.60488 6.86707 8.36341C7.10854 8.12195 7.51097 8.12195 7.75244 8.36341L10.5695 11.1805C11.1329 11.8244 11.9378 12.1463 12.8232 12.1463C13.7085 12.1463 14.4329 11.7439 15.0768 11.1805C15.7207 10.6171 16.0427 9.8122 16.0427 8.92683C16.0427 8.04146 15.7207 7.23659 15.1573 6.59268C14.5939 5.94878 13.789 5.62683 12.9037 5.62683C12.1793 5.62683 11.5354 5.86829 10.972 6.27073C10.7305 6.43171 10.4085 6.43171 10.1671 6.19024C9.92561 5.94878 9.92561 5.54634 10.2476 5.30488C10.972 4.82195 11.8573 4.5 12.8232 4.5Z"
      fill="#1D192B"
    />
  </svg>
);

export default SvgMix;
